<template>
  <div id="app" :class="themeName">
    <sidePanel  handler-func=""/>
    <router-view />
  </div>
</template>
<script>
import sidePanel from "@/components/sidePanel.vue";
export default {
  name: 'app',
  components: {
    sidePanel,
  },
  data() {
    return {
      theme: '',
    };
  },
  computed: {
    themeName() {
      let theme = localStorage.getItem('theme');
      if (theme === null || theme === undefined) {
        theme = 'default-theme';
      }
      if (localStorage.getItem('pin-head') != null) {
        theme += ' pin-head';
      }
      return theme;
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      const panel = document.getElementById("side-panel-right");
      const panelResizer = document.getElementById("side-panel-right-resizer");
      let startXpos;
      let panelWidth = 0;

      function resizeX(e) {
        const dx = e.x - startXpos;
        console.log("run resizer", panelWidth, dx, panel.style.width, startXpos, e.x);
        panel.style.width = (panelWidth - dx) + "px";
      }

      if (panelResizer != null) {
        panelResizer.addEventListener("mousedown", function(e) {
          startXpos = e.x;
          panelWidth = parseInt(getComputedStyle(panel).width);
          document.addEventListener("mousemove", resizeX);
          console.log("start resizer", panelWidth, startXpos);
          panelResizer.classList.add("width-100-percent");
        });

        document.addEventListener("mouseup", function() {
          document.removeEventListener("mousemove", resizeX);
          console.log("end resizer");
          panelResizer.classList.remove("width-100-percent");
        });
      }
      if (localStorage.getItem('favicon')) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = localStorage.getItem('favicon');
      }
    })
  },
  created: function () {
    this.theme = localStorage.getItem('theme');
    document.body.classList.add(this.theme);
    if (localStorage.getItem('pin-head') != null) {
      document.body.classList.add('pin-head');
    }
  },
}
</script>

<style lang="scss">
.please_utf8 {
  content: "ф"
}
@import "./assets/css/encode.scss";

$fa-font-path: "~font-awesome/fonts";
@import '~font-awesome/scss/font-awesome';

//@import "~simple-line-icons/scss/simple-line-icons";

@import "~@coreui/coreui/scss/coreui";

//@import "~@coreui/icons/scss/coreui-icons";

//@import "~pace-progress/themes/blue/pace-theme-minimal.css";

@import "~toastr/toastr";

@import "~codemirror/lib/codemirror.css";

@import "~bootstrap-select/sass/bootstrap-select";

@import "./assets/css/bootstrap-custom.scss";

@import "./assets/css/main.scss";

@import "./assets/css/dashboard.scss";

@import "./assets/css/dashboard-table.scss";

@import "./assets/css/login.scss";

@import "./assets/css/sidebar.scss";

</style>